/** Options and tone styling for SOX dashboard workflow status (use with Select as StatusSelect). */

export const SOX_DASHBOARD_STATUS_OPTIONS = [
  { value: 'open', label: 'Open' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'in_review', label: 'In Review' },
  { value: 'complete', label: 'Complete' }
];

const CANONICAL = new Set(['open', 'in_progress', 'in_review', 'complete']);

/** Maps legacy / alternate API strings to canonical workflow values. */
const LEGACY_TO_CANONICAL = {
  draft: 'open',
  to_do: 'open',
  todo: 'open',
  open: 'open',
  'to do': 'open',
  flagged: 'in_review',
  active: 'in_review',
  under_review: 'in_progress',
  'under review': 'in_progress',
  'in progress': 'in_progress',
  in_progress: 'in_progress',
  'in review': 'in_review',
  in_review: 'in_review',
  complete: 'complete'
};

export function normalizeSoxDashboardProcessStatus(status) {
  if (!status || typeof status !== 'string') return 'open';
  const raw = status.trim();
  const underscored = raw.toLowerCase().replace(/\s+/g, '_');
  if (LEGACY_TO_CANONICAL[underscored]) return LEGACY_TO_CANONICAL[underscored];
  if (LEGACY_TO_CANONICAL[raw.toLowerCase()]) return LEGACY_TO_CANONICAL[raw.toLowerCase()];

  const match = SOX_DASHBOARD_STATUS_OPTIONS.find(
    (o) => o.value === underscored || o.value.toLowerCase() === raw.toLowerCase()
  );
  if (match) return match.value;
  if (CANONICAL.has(underscored)) return underscored;
  return 'open';
}

/** Tone map for optional custom styling on Select (matches dashboard pill colors). */
export function getSoxDashboardStatusPillTone(value) {
  switch (normalizeSoxDashboardProcessStatus(value)) {
    case 'open':
      return { backgroundColor: '#f3f4f6', borderColor: '#e5e7eb', color: '#1f2937' };
    case 'in_progress':
      return { backgroundColor: '#f0f9ff', borderColor: '#bae6fd', color: '#075985' };
    case 'in_review':
      return { backgroundColor: '#eff6ff', borderColor: '#93c5fd', color: '#1e40af' };
    case 'complete':
      return { backgroundColor: '#ecfdf5', borderColor: '#6ee7b7', color: '#065f46' };
    default:
      return { backgroundColor: '#f3f4f6', borderColor: '#e5e7eb', color: '#1f2937' };
  }
}
